export default {
  "common": {
    "all": "Semua",
    "cancel": "Batal",
    "userAgreement": "Perjanjian Pengguna",
    "close": "Tutup",
    "submit": "Hantar",
    "submitting": "Menghantar...",
    "report": "Aduan",
    "loading": "Memuatkan...",
    "noMore": "Tiada lagi",
    "search": "Cari",
    "today": "Hari Ini",
    "collapse": "Kecilkan",
    "retryLater": "Cuba lagi nanti",
    "tips": "Petua",
    "friendlyReminder": "Petua yang Mesra",
    "finish": "Selesai",
    "noData": "Tiada data yang berkaitan",
    "retry": "Cuba lagi",
    "reset": "Tetap semula",
    "confirm": "Sahkan",
    "continue": "Teruskan",
    "notAvailableYet": "Belum tersedia"
  },
  "tab": {
    "home": "Home",
    "card": "Kad",
    "mine": "Akaun Saya"
  },
  "auth": {
    "loginTitle": "Dompet Web3 Pay",
    "loginSubtitle": "A single card connects assets and consumption, effortlessly unlocking a global payment experience",
    "createWallet": "Cipta Wallet",
    "importWallet": "Dompet saya",
    "choiceOneWay": "Choose a method to quickly start your secure digital asset journey",
    "iHaveWallet": "Dompet saya",
    "choiceOneWay2": "Pilih satu kaedah log masuk untuk memulakan perjalanan aset digital anda dengan selamat",
    "createUseEmail": "Cipta dengan E-mel",
    "createUseRemWord": "Cipta Dompet Frasa Mnemonik",
    "loginUseEmail": "Log masuk dengan E-mel",
    "loginByReWord": "Import dengan Kunci Peribadi / Frasa Mnemonik",
    "validByEmail": "Pengesahan pantas melalui e-mel, mudah dan praktikal",
    "validByReWord": "Dikawal sepenuhnya oleh frasa mnemonik, selamat dan terdesentralisasi",
    "validByReWord2": "Import dengan frasa mnemonik/kunci peribadi/alamat dompet",
    "emailLoginRegister": "Email Login/Register",
    "inviteRegisterTitleStart": "Bayar sekali sentuh,",
    "inviteRegisterTitleEnd": "jadi mudah",
    "inviteRegisterStartRewards": "Buka Ganjaran",
    "inviteRegisterWelcome": "Selamat datang ke WinPay!",
    "agreePrefix": "By continuing to use, you agree to the WinPay Wallet's ",
    "privacyPolicy": "Privacy Policy",
    "and": "dan",
    "userAgreement": "Perjanjian Pengguna",
    "agreementMessage": "Please read the Privacy Policy and User Agreement first. Clicking 'Continue' indicates that you agree to the WinPay Wallet's Privacy Policy and User Agreement.",
    "agreementConfirm": "Saya telah membaca dan bersetuju",
    "addEmailAddress": "Tambah e-mel",
    "inputEmailAddress": "Masukkan e-mel",
    "emailAccountTip": "E-mel ini akan menjadi akaun log masuk anda.",
    "emailAddress": "Alamat e-mel",
    "email": "E-mel",
    "emailLogin": "Log Masuk E-mel",
    "enterEmail": "Masukkan emel anda",
    "enterEmailAddress": "Masukkan e-mel",
    "register": "Daftar",
    "login": "Log masuk",
    "enterVerificationCode": "Masukkan kod",
    "codeSentTo": "Kod dihantar ke ",
    "codeSentToEmail": "Kod pengesahan telah dihantar ke e-mel anda:",
    "codeValid": ", sah 10 minit.",
    "emailCode": "Kod emel",
    "enterEmailCode": "Enter email code",
    "getCode": "Dapatkan kod",
    "resend": "Hantar Semula",
    "codeSent": "Kod telah dihantar",
    "codeSentValid": "*Kod dihantar. Sah 10 minit",
    "cannotReceiveCode": "Tidak menerima kod?",
    "checkSpamFolder": "Semak folder spam",
    "codeHelpTitle": "Tidak menerima kod pengesahan?",
    "codeHelpIntro": "Kod pengesahan biasanya dihantar dalam masa 1 minit. Jika anda masih belum menerimanya:",
    "codeHelpEmailTitle": "Semak sama ada e-mel betul",
    "codeHelpEmailDesc": "Pastikan kod dihantar ke alamat e-mel yang anda jangkakan. Kesilapan ejaan kecil ialah sebab paling biasa kod tidak dihantar.",
    "codeHelpSpamTitle": "Semak folder spam",
    "codeHelpSpamDesc": "E-mel pengesahan kadangkala ditandakan sebagai spam. Tandakan sebagai bukan spam supaya kod seterusnya dapat dihantar ke peti masuk anda.",
    "codeHelpResendTitle": "Minta kod pengesahan baharu",
    "codeHelpResendDesc": "Pastikan anda menggunakan kod pengesahan terkini kerana kod lama akan luput.",
    "verify": "Sahkan",
    "inputPassword": "Masukkan Kata Laluan",
    "setWalletPassword": "Tetapkan kata laluan dompet",
    "walletPasswordTip": "Set a password to manage your wallet. This password cannot be recovered. If you forget your password, you can go to my homepage - Security Settings - Retrieve Password, or log in again with your email and reset your payment password!",
    "setPasswordForTransaction": "Tetapkan kata laluan dompet untuk pengesahan.",
    "strongPassword": "Masukkan kata laluan yang kuat",
    "enterPasswordPlaceholder": "Sila masukkan kata laluan",
    "enterPassword": "Masukkan",
    "confirmPassword": "Masukkan kata laluan sekali lagi",
    "passwordTooShort": "*Password is too short. At least 8 characters.",
    "passwordWeak": "Kata laluan lemah",
    "passwordMedium": "Kata laluan sederhana",
    "passwordStrong": "Kata laluan kuat",
    "passwordMismatch": "Kata laluan tidak sepadan",
    "passwordError": "Ralat kata laluan",
    "bindEmail": "Sambungkan emel",
    "bindEmailIntro": "Untuk keselamatan dana anda, sila sambungkan emel",
    "emailForRecovery": "Digunakan untuk memulihkan kata laluan",
    "emailRequired": "Emel tidak boleh kosong",
    "codeRequired": "Kod tidak boleh kosong",
    "invitationCode": "Kod jemputan",
    "enterInvitationCode": "Masukkan kod jemputan (pilihan)",
    "verificationFailed": "Pengesahan gagal",
    "walletReady": "Wallet ready",
    "walletCreatedSuccess": "Welcome Back!",
    "walletExploreTip": "WinPay full functionality enabled",
    "firstExploreCreateTitle": "Wallet created successfully!",
    "firstExploreRegisterTitle": "Login successful!",
    "firstExploreLoginTitle": "Welcome back!",
    "firstExploreImportTitle": "Wallet imported successfully!",
    "firstExploreCreateSubtitle": "You can now explore the public-chain crypto wallet",
    "firstExploreDefaultSubtitle": "WinPay full functionality enabled",
    "startExplore": "Mulakan penerokaan",
    "importTitle": "Masukkan frasa mnemonik atau kunci peribadi",
    "importWalletTip": "Separate mnemonic words with spaces. Supports importing from any wallet.",
    "importPlaceholder": "Masukkan frasa mnemonik atau kunci peribadi",
    "importInvalid": "Invalid input",
    "importTip1": "WinPay Wallet does not store your mnemonic or private key. You control your assets.",
    "importTip2": "Make sure no one else or camera can see your secret.",
    "importTip3": "Adalah disyorkan agar anda menaip sendiri atau mengimbas kod QR untuk mengimport frasa mnemonik atau kunci peribadi anda.",
    "continue": "Teruskan",
    "backupWarnTitle": "Ingat Sebelum Membuat Sandaran!",
    "backupTipWrite": "Disarankan untuk Menulis Tangan",
    "backupTipNoCopy": "Jangan Salin dan Simpan",
    "backupTipNoScreenshot": "Jangan Simpan Sebagai Tangkapan Skrin",
    "backupWarn1Title": "Frasa Mnemonik Sama dengan Kata Laluan Dompet Anda",
    "backupWarn1Desc": "Anyone with your mnemonic controls your assets. Leaks are irreversible.",
    "backupWarn2Title": "Sila Tulis Tangan atau Simpan dalam Dompet Sejuk atau Peranti Luar Talian",
    "backupWarn2Desc": "Jika Disalin atau Disimpan Sebagai Tangkapan Skrin, Frasa Mnemonik Mungkin Terdedah",
    "backupWarn3Title": "Simpan Frasa Mnemonik Anda di Tempat yang Selamat",
    "backupWarn3Desc": "Jika Hilang, Aset Tidak Boleh Dipulihkan",
    "backupWarnCheck": "You are responsible for your mnemonic. Back it up — loss means permanent asset loss.",
    "backupMnemonic": "Backup Frasa Pemulihan",
    "mnemonicDesc": "Frasa pemulihan ialah kata laluan dompet anda. Sila simpan dengan selamat.",
    "verifyMnemonicTitle": "Sahkan Frasa Ingatan",
    "verifyMnemonicTip": "Sila Sahkan Frasa Mnemonik Mengikut Urutan",
    "ordinalNumber": "Word {number}",
    "mnemonicCheckFailed": "Pengesahan frasa mnemonik gagal",
    "mnemonicCheckSuccess": "Pengesahan frasa mnemonik berjaya",
    "mnemonicUnavailable": "No mnemonic backup available for this wallet",
    "verifyWalletPassword": "Enter payment password",
    "forgotPasswordRecovery": "Lupa kata laluan? Tetapkan semula",
    "resetPaymentPassword": "Pulihkan kata laluan",
    "resetPaymentPasswordTip": "Verify your bound email first, then reset the payment password",
    "changePassword": "Tukar kata laluan",
    "currentPassword": "Kata laluan semasa",
    "enterCurrentPassword": "Masukkan kata laluan semasa",
    "setPassword": "Tetapkan kata laluan",
    "pleaseSetNewPasswordMin8": "Tetapkan kata laluan baharu, sekurang-kurangnya 8 aksara",
    "newPassword": "Kata laluan baru",
    "setNewPasswordMin8": "Set a new password with at least 8 characters",
    "enterNewPassword": "Masukkan kata laluan baru",
    "confirmNewPassword": "Sahkan kata laluan baru",
    "setNewPasswordAgain": "Sila sahkan semula kata laluan baru yang ditetapkan",
    "currentPasswordIncorrect": "Kata laluan semasa tidak betul",
    "newPasswordSameAsOld": "Kata laluan baharu tidak boleh sama dengan kata laluan lama",
    "passwordsNotMatch": "Kata laluan baru tidak sepadan",
    "passwordOnlySavedLocally1": "Saya sedar bahawa kata laluan hanya disimpan secara tempatan di peranti ini,",
    "passwordOnlySavedLocally2": "dan tidak dapat dipulihkan jika terlupa.",
    "noBoundEmailRecover": "Anda belum menyambungkan emel, tidak boleh memulihkan kata laluan",
    "goBindEmail": "Sambungkan emel",
    "boundEmail": "Sahkan emel",
    "changeSuccess": "Berjaya mengubah",
    "bindEmailTip": "Sila ikat e-mel dahulu sebelum mendapatkan semula kata laluan",
    "bindEmailTip2": "Ikat e-mel anda sebelum memulihkan kata laluan untuk menerima mesej pengesahan.",
    "bindEmailTip3": "Sila ikat e-mel anda terlebih dahulu",
    "noBindEmail": "Tidak",
    "canUseWallet": "Tahniah, anda boleh menggunakan dompet sekarang!",
    "successfullyProtected": "Anda telah berjaya melindungi dompet anda. Ingat, jika frasa ingatan anda hilang, ia tidak dapat dipulihkan! Anda boleh membuat sandaran dengan pergi ke Tetapan → Pengurusan Dompet → Pilih Dompet → Eksport Frasa Ingatan pada bila-bila masa.",
    "startUseApp": "Mula guna WinPay Wallet",
    "next": "Seterusnya"
  },
  "home": {
    "title": "Home",
    "totalAssets": "Jumlah aset",
    "receive": "Terima",
    "scan": "Imbas",
    "transfer": "Pemindahan",
    "topup": "Top Up",
    "withdraw": "Pengeluaran",
    "bill": "Aliran Kewangan",
    "invite": "Jemput",
    "invitCode": "Kod QR jemputan",
    "more": "Lebih",
    "recent": "Shortcuts",
    "community": "Komuniti",
    "token": "Token",
    "turnover": "Pusingan",
    "nft": "NFT",
    "accountAssets": "Aset akaun",
    "cardAssets": "Aset dalam kad",
    "cardWallet": "Kad",
    "backup": "Pergi Sandaran",
    "winpayCardPayment": "WinPay Virtual Card + Physical Card Dual Payment Support",
    "applyExclusiveCard": "Mohon Kad Eksklusif",
    "nodeFast": "Node OK",
    "nodeSlow": "Node Slow",
    "nodeBad": "Node Error",
    "node": "Node",
    "viewAccount": "Pilih Akaun",
    "selectAccount": "Pilih Akaun",
    "selectNode": "Pilih nod",
    "blockHeightExplain": "Lower latency and newer block height usually mean a better node connection.",
    "recommendNode": "Aanbevolen knoop",
    "blockHeight": "Blokhogte",
    "currentAccountNotSupport": "The current account does not support this network.",
    "noData": "Tiada data",
    "actionTodo": "Belum tersedia",
    "cardTailNo": "Nombor akhir",
    "tradeSuccess": "Transaksi berjaya",
    "tradeFailed": "Transaksi gagal",
    "kycRetryRequired": "KYC gagal. Sahkan semula.",
    "viewNow": "Lihat sekarang"
  },
  "wallet": {
    "chooseCoin": "Pilih mata wang lain",
    "chooseNetwork": "Pilih Rangkaian",
    "copyAddress": "Salin alamat",
    "copySuccess": "Berjaya Disalin",
    "copyFailed": "Gagal Menyalin",
    "saveSuccess": "Simpan berjaya",
    "saveFailed": "Save failed",
    "depositAddress": "Deposit Address",
    "topupNotes": "Makluman penting:",
    "topupNote1Prefix": "1. Jumlah tambah nilai adalah berdasarkan",
    "topupNote1Highlight1": "“jumlah sebenar yang diterima”",
    "topupNote1Middle": "dan berbeza antara platform",
    "topupNote1Highlight2": "“jumlah sebenar yang diterima”",
    "topupNote1Suffix": " may differ across platforms because outgoing platform fees are deducted before arrival.",
    "topupNote2": "2. Do not deposit any non-USDT assets to the address above, or the assets may not be recoverable.",
    "topupNote3": "3. After depositing to the address above, network confirmation is required. Funds arrive after 60 confirmations and can be withdrawn after 910 confirmations.",
    "withdrawAddress": "Withdraw Address",
    "enterWithdrawAddress": "Masukkan alamat pengeluaran",
    "withdrawAmount": "Withdraw Amount",
    "withdrawAmountLabel": "Kuantiti",
    "maxAmountLabel": "Maximum Amount",
    "available": "Boleh digunakan",
    "enterAmount": "Masukkan jumlah",
    "enterWithdrawAmount": "Masukkan jumlah pengeluaran",
    "all": "Semua",
    "fee": "Yuran",
    "received": "Anggaran penerimaan",
    "submitWithdraw": "Hantar permohonan pengeluaran",
    "withdrawNotes": "Makluman penting:",
    "withdrawNote1Prefix": "1. Minimum withdrawal amount is ",
    "withdrawNote2": "2. Please ensure the withdrawal address is accurate, otherwise assets cannot be recovered.",
    "withdrawNote3Prefix": "3. Selepas semakan,",
    "withdrawNote3Suffix": "jam diperlukan untuk penerimaan. Kelewatan mungkin berlaku kerana faktor rangkaian.",
    "withdrawNote4": "4. Jika tidak diterima dalam masa yang lama, sila hubungi sokongan pelanggan untuk semakan.",
    "withdrawUnavailable": "Pengeluaran tidak tersedia buat masa ini.",
    "withdrawConfirm": "Confirm withdrawal?",
    "withdrawSuccess": "Permohonan pengeluaran telah berjaya dihantar. Sila tunggu semakan pentadbir.",
    "billTitle": "Aliran Kewangan",
    "billDetailTitle": "Butiran",
    "noBill": "No records",
    "noBillDetail": "Tiada data yang berkaitan",
    "assetType": "Jenis",
    "recordType": "Record Type",
    "billTimeLabel": "Masa",
    "choosePricingFiat": "Pilih mata wang penilaian",
    "hotFeatures": "Ciri Popular",
    "moreFeatures": "Lebih Banyak Fungsi",
    "walletFeatures": "Ciri Popular",
    "cardFeatures": "Fungsi Kad",
    "otherFeatures": "Fungsi Lain",
    "payment": "Terima",
    "scanCode": "Imbas",
    "walletBackup": "Sandaran Dompet",
    "openCard": "Open Card Now",
    "GoOpenCard": "Go open the card",
    "physicalCard": "Fungsi kad fizikal",
    "physicalUnavailable": "The physical card feature is temporarily unavailable. Stay tuned!",
    "activateCard": "Aktifkan kad fizikal",
    "physicalTransfer": "Physical Transfer",
    "fundTransfer": "Pemindahan Dana",
    "fundTransferUnavailable": "Ciri ini belum tersedia. Nantikan kemas kini!",
    "receiveAddress": "Alamat penerima",
    "saveCollectionCode": "Simpan kod kutipan",
    "transferInProperty": "Only transfer assets through {network}",
    "receiveTips": "Receive Tips",
    "receiveTip1": "Confirm the asset and current network before receiving.",
    "receiveTip2": "Wrong network or coin transfers may not be recoverable.",
    "openCamera": "Open Camera",
    "closeCamera": "Close Camera",
    "pasteScanResult": "Paste or enter scan result",
    "scanResult": "Scan Result",
    "cameraUnavailable": "Camera is unavailable in this browser",
    "cameraPermissionDenied": "Camera access is blocked. Please allow camera permission first.",
    "cameraPermissionHint": "If no permission prompt appears, check whether camera access is allowed in site permissions.",
    "cameraNotFound": "No camera device was found.",
    "cameraInUse": "Camera is currently being used by another app. Please close it and try again.",
    "cameraConstraintFailed": "The requested camera mode is not supported on this device, and fallback also failed.",
    "cameraSecureContextRequired": "This page is not running in a camera-safe browser context.",
    "cameraSecureContextHint": "On Android browsers, webpage camera access usually requires HTTPS or localhost. Using a LAN http address often will not trigger camera permission directly.",
    "cameraGuideTitle": "Unable to open camera",
    "iosCameraGuideTitle": "iPhone camera guide",
    "androidCameraGuideTitle": "Android camera guide",
    "cameraPermissionGuide": "1. In iPhone Safari, tap the \"aA\" button or the page menu near the address bar.<br/>2. Open Website Settings and change Camera to Allow.<br/>3. Return to this page, refresh it, and tap scan again.<br/>4. If you previously tapped \"Don’t Allow\", also check camera access in iPhone Settings for Safari.",
    "cameraSecureGuide": "This page must be opened in a secure context to access the camera.<br/>1. Make sure you are using the official domain or a secure link.<br/>2. Refresh the page and try again.<br/>3. If it still fails, reopen it in the system browser.",
    "cameraUnavailableGuide": "1. First make sure the iPhone camera works normally in the system Camera app.<br/>2. Check whether camera access is allowed for this website in Safari.<br/>3. Close any other app that may be using the camera, then try again.<br/>4. If it still fails, refresh the page or re-enter and retry.",
    "iosCameraPermissionGuide": "1. In iPhone Safari, tap the \"aA\" button or the page menu near the address bar.<br/>2. Open Website Settings and change Camera to Allow.<br/>3. Return to this page, refresh it, and tap scan again.<br/>4. If you previously tapped \"Don’t Allow\", also check camera access in iPhone Settings for Safari.",
    "iosCameraSecureGuide": "This page must be opened in a secure context to access the camera.<br/>1. Make sure you are using the official domain or a secure link.<br/>2. Refresh the page and try again.<br/>3. If it still fails, reopen it in the system browser.",
    "iosCameraUnavailableGuide": "1. First make sure the iPhone camera works normally in the system Camera app.<br/>2. Check whether camera access is allowed for this website in Safari.<br/>3. Close any other app that may be using the camera, then try again.<br/>4. If it still fails, refresh the page or re-enter and retry.",
    "androidCameraPermissionGuide": "1. Open Site Settings or Permissions in your Android browser for this website.<br/>2. Change Camera permission to Allow.<br/>3. If the system camera permission was denied before, open Android Settings - Apps - Browser - Permissions and allow Camera.<br/>4. Return to the page, refresh it, and tap scan again.",
    "androidCameraSecureGuide": "Most Android browsers require a secure context for camera access.<br/>1. Make sure the page is opened from the official domain or an HTTPS link.<br/>2. If you are using a LAN address, many Android browsers will not trigger camera permission.<br/>3. Switch to the official address, refresh the page, and try again.",
    "androidCameraUnavailableGuide": "1. First make sure the system Camera app works normally on your phone.<br/>2. Check that both the browser and Android system allow camera permission.<br/>3. Close other apps that may be using the camera and try again.<br/>4. If it still fails, refresh the page or try the system browser.",
    "androidScanGuideTitle": "Android scan guide",
    "androidScanGuide": "The camera is open, but this Android browser does not support the live scanning capability used on this page.<br/>1. Try the system browser or the latest Chrome first.<br/>2. Make sure camera permission is allowed for this website.<br/>3. Refresh the page and try again. If it still fails, switch to a browser that supports live web scanning.",
    "safariScanGuideTitle": "Safari scan guide",
    "safariScanGuide": "The camera is open, but iPhone Safari does not support the live scanning capability used on this page.<br/>1. First confirm camera permission is allowed for this website.<br/>2. Refresh the page and try once more.<br/>3. If it still cannot scan, please use a browser that supports live web scanning or complete scanning from another entry.",
    "scanNotSupportedGuide": "This browser does not support the live scanning capability used on this page.<br/>1. Make sure camera permission is already allowed for this website.<br/>2. Refresh the page and try once more.<br/>3. If it still fails, please switch to the system browser or another browser that supports live web scanning.",
    "scanNotSupported": "This browser does not support live QR scanning. Please try again in your system browser.",
    "scanSuccess": "Scanned",
    "transferRecord": "Rekod pindahan akaun",
    "directTransfer": "Pindahan terus",
    "addressBookTransfer": "Pindahan alamat",
    "scanTransfer": "Pindahan imbas",
    "enterOrPasteAddress": "Enter or paste address",
    "transferAmount": "Jumlah pindahan",
    "transferHistory": "Sejarah pindahan",
    "noTransferRecord": "No transfer records",
    "transferConfirm": "Confirm transfer?",
    "addToken": "Tambah token",
    "addNft": "Tambah NFT",
    "nftDetail": "Butiran NFT",
    "nftAssets": "Baki",
    "nftAssetView": "NFT",
    "nftSendTitle": "Hantar NFT",
    "nftSendAsset": "Baki",
    "sendNft": "Hantar",
    "removeNft": "Padam",
    "invalidAddress": "Please enter a valid address",
    "nftTransferUnsupported": "NFT transfer is not supported on the current network",
    "nftSendSuccess": "Berjaya dihantar",
    "hotToken": "Token popular",
    "hotNft": "NFT Popular",
    "customToken": "Token tersuai",
    "customNft": "NFT Tersuai",
    "enterContractAddressSearch": "Enter contract address to search",
    "tokenAddress": "Alamat token",
    "nftAddress": "NFT Address",
    "enterTokenAddress": "Masukkan alamat token",
    "enterNftAddress": "Enter NFT contract address",
    "tokenSymbol": "Simbol token",
    "enterTokenSymbol": "Masukkan simbol token",
    "decimalPlaces": "Tempat perpuluhan",
    "tokenAdded": "Token ditambah",
    "addSuccess": "Berjaya ditambah",
    "tokenDetail": "Butiran Token",
    "propertyBalance": "Baki Aset",
    "transferIn": "Pindahan masuk",
    "transferOut": "Pindahan keluar",
    "transferInAddress": "Alamat Pindahan Masuk",
    "transferOutAddress": "Alamat Pemindahan",
    "transactionId": "ID Transaksi",
    "blockchainBrowser": "Penyemak Imbas Blockchain",
    "network": "Rangkaian",
    "pending": "Pending",
    "inTransaction": "Dalam Transaksi",
    "finish": "Selesai",
    "signTodo": "Signing flow migration in progress",
    "exportMnemonic": "Eksport frasa",
    "exportPrivateKey": "Eksport Kunci Peribadi",
    "sensitiveExportLabel": "Identity verification required",
    "securityReminder": "Peringatan Keselamatan",
    "backupTip1": "Mnemonic and private key control your assets. Keep them offline.",
    "backupTip2": "Do not screenshot, record, or send them to anyone.",
    "backupTip3": "WinPay never stores your mnemonic or private key.",
    "backupSensitiveConfirm": "Make sure your surroundings are secure before continuing.",
    "sensitiveExportTodo": "Sensitive export flow migration in progress",
    "privateKeyUnavailable": "No private key export available for this wallet",
    "specialReminder": "Peringatan khas",
    "safetyReminder": "Peringatan Keselamatan",
    "privateCarefulExport": "After exporting the private key, store it offline with extreme care. Exposure may lead to asset loss.",
    "clickShowPrivateKeyQr": "Klik untuk papar kod QR kunci persendirian",
    "plaintextPrivateKey": "Kunci Persendirian Teks Rata",
    "copyPrivateKey": "Salin Kunci Persendirian",
    "copyPrivateKeyAfter": "After copying the private key, be sure to store it properly, otherwise it may cause asset loss.",
    "copyMnemonicAfter1": "Sila tulis pada kertas",
    "copyMnemonicAfter2": "Disyorkan untuk menyimpannya di atas kertas.",
    "copyMnemonicAfter3": "Masukkan mengikut urutan yang betul untuk meneruskan.",
    "notPasteMnemonic1": "Jangan simpan frasa mnemonik dalam persekitaran rangkaian.",
    "notPasteMnemonic2": "frasa ingatan anda ke aplikasi yang berhubung dengan internet,",
    "notPasteMnemonic3": "Jangan tampal ke mana-mana persekitaran dalam talian.",
    "notPasteMnemonic4": "simpan di perkhidmatan penyimpanan dalam talian atau alat perbualan",
    "notShareMnemonic1": "Jangan kongsi frasa ingatan anda dengan sesiapa pun,",
    "notShareMnemonic2": "kami tidak akan pernah meminta frasa ingatan anda",
    "winpayCard": "WinPay Card",
    "openCardTitle": "Buka Kad Sekarang",
    "openCardDesc": "Connect account assets with global payments",
    "openCardProcess": "Open Card Flow",
    "openCardStep1": "Pengesahan KYC",
    "openCardStep2": "Pilih kad",
    "openCardStep3": "Aktifkan",
    "cardSecure": "Selamat",
    "cardSecureDesc": "Risk controls",
    "cardGlobal": "Global",
    "cardGlobalDesc": "Multi-scenario payments",
    "cardAsset": "Baki",
    "cardAssetDesc": "Unified balance",
    "openCardNow": "Buka Kad Sekarang",
    "cardKycTodo": "Card KYC flow migration in progress",
    "activatePhysicalCard": "Aktifkan kad fizikal",
    "activatePhysicalCardEntry": "Aktifkan kad fizikal",
    "activatePhysicalDesc": "Enter card number and activation code after receiving the card",
    "cardNumber": "Nombor Kad",
    "enterCardNumber": "Enter card number",
    "activeCode": "Kod Pengaktifan",
    "enterActiveCode": "Enter activation code",
    "emailCode": "Kod emel",
    "enterEmailCode": "Enter email code",
    "sendCode": "Send Code",
    "activateNow": "Activate Now",
    "activateTip1": "Activate only after receiving the physical card.",
    "activateTip2": "Check card number, email code, and activation code before submitting.",
    "cardApiTodo": "Card API migration in progress",
    "completeCardActiveForm": "Complete activation information",
    "activateSuccess": "Activated",
    "submitSuccess": "Submitted successfully",
    "physicalTransferDesc": "Balance transfer between physical cards",
    "fromCard": "From Card",
    "selectCard": "Pilih",
    "toCard": "To Card",
    "enterTargetCard": "Enter target card number",
    "remark": "Catatan",
    "optionalRemark": "Optional",
    "completePhysicalTransferForm": "Complete transfer information",
    "transferFrom": "Dari",
    "transferTo": "Ke",
    "fundingAccount": "Akaun dana",
    "exchangeCoin": "Exchange Asset",
    "availableBalance": "Available Balance",
    "transferInAmount": "Transfer In Amount",
    "transferOutAmount": "Transfer Out Amount",
    "withdrawFeeLabel": "Yuran Pengeluaran",
    "failed": "Gagal"
  },
  "invite": {
    "title": "Jemput",
    "inviteNow": "Jemput Sekarang",
    "share": "Kongsi",
    "claim": "Tuntut",
    "claimSuccess": "Dituntut",
    "pendingClaim": "Boleh Dituntut",
    "claimableAmount": "Boleh dituntut (USDT)",
    "claimed": "Telah dituntut",
    "expired": "Tamat tempoh",
    "copyUrl": "Salin pautan",
    "saveQrCode": "Simpan QR",
    "saveImage": "Simpan",
    "posterTitle": "Satu Kad · Bayar Global",
    "posterTagline": "Pembayaran Global · Satu Dompet",
    "pointsRules": "Peraturan jemputan",
    "referralStepsTitle": "Langkah Rujukan",
    "pointsRulesComingSoon": "Akan datang",
    "heroTitle": "Ganjaran Rujukan",
    "hero1": "Rujuk & Dapat",
    "hero2": "60%",
    "hero3": "Ganjaran",
    "heroDesc": "Lihat Syarat & Raih Ganjaran",
    "partner": "Rakan Kongsi",
    "partnerPromotion": "Jadi Rakan WinPay. Jana Lebih.",
    "partnerJoinNow": "Sertai Sekarang",
    "coursePromotionTitle": "Langkah Rujukan",
    "purchaseCardToInvite": "Beli kad untuk membuka jemputan",
    "purchaseCardToInviteDesc": "Anda telah melengkapkan pengesahan identiti. Beli kad maya atau fizikal untuk mendapatkan kod jemputan dan pautan jemputan eksklusif, kemudian mula memperoleh ganjaran jemputan.",
    "unlockInviteTitle": "Syarat untuk membuka kod dan pautan jemputan:",
    "unlockInviteDesc": "Beli mana-mana kad untuk mendapatkan kod dan pautan jemputan eksklusif anda.",
    "purchaseCardToInviteLater": "Kemudian",
    "purchaseCardToInviteNow": "Beli kad sekarang",
    "kycPurchaseCardDesc": "Selesaikan pengesahan identiti, kemudian beli kad maya atau fizikal untuk membuka ciri ini.",
    "coursePromotionDesc": "Lihat cara jemput & raih ganjaran",
    "cardOpeningCommission": "Komisen menjemput rakan untuk membuka kad",
    "cardOpeningCommissionShort": "Komisen buka kad",
    "spendingCommission": "Komisen perbelanjaan",
    "commissionRefundDeduction": "Potongan komisen akibat bayaran balik",
    "reservedReward": "Dikhaskan",
    "courseCommission": "Komisen pembukaan kad Tahap 2",
    "globalDirectorCourseCommission": "Komisen pembukaan kad Tahap 2 Pengarah Global Tunggal",
    "globalDirectorCardOpeningCommission": "Komisen pembukaan kad Pengarah Global Tunggal",
    "teamBonusPoolCardOpeningCommission": "Komisen pembukaan kad kumpulan bonus pasukan",
    "teamBonusPoolCourseCommission": "Komisen pembukaan kad Tahap 2 kumpulan bonus pasukan",
    "globalDirectorTeamCardOpeningCommission": "Komisen pembukaan kad pasukan Pengarah Global Tunggal",
    "globalDirectorTeamCourseCommission": "Komisen pembukaan kad Tahap 2 pasukan Pengarah Global Tunggal",
    "inviteFriendCardOpeningCommission": "Komisen daripada menjemput rakan membuka kad",
    "invitationCommission": "Rujukan",
    "purchaseCommission": "Kad",
    "consumptionCommission": "Komisen L2",
    "friendCourseCommission": "Komisen pembukaan kad Tahap 2 rakan",
    "inviteFriendCourseCommission": "Komisen pembukaan kad Tahap 2 daripada rakan yang dijemput",
    "monthlyCommission": "Bulanan",
    "monthlyBonusPoolCommission": "Ganjaran Pasukan",
    "globalDirectorExclusiveCommission": "Komisen Eksklusif Pengarah Global Tunggal",
    "globalDirectorCardOpeningReward": "Ganjaran Pembukaan Kad Pengarah Global Tunggal",
    "monthlyCommissionTitle": "Pasukan",
    "monthlyCommissionIntro": "Kumpul lebih daripada 5 pembukaan kad sah daripada rujukan langsung untuk melayakkan diri menerima ganjaran pasukan V3.",
    "monthlyCommissionTip1": "Penyelesaian komisen buka kad",
    "monthlyCommissionTip1Desc": "Selepas mencapai V3, jemput rakan melengkapkan pembukaan kad yang sah untuk menerima ganjaran.",
    "monthlyCommissionTip2": "Ganjaran mengikut tahap",
    "monthlyCommissionTip2Desc": "Dikira dua kali sebulan; tahap T ditentukan berdasarkan bilangan rujukan langsung yang sah.",
    "monthlyCommissionTip3": "Penerangan ganjaran pasukan",
    "monthlyCommissionTip3Desc": "Selepas rakan melengkapkan pembelian kursus yang sah, ganjaran tersebut menyumbang kepada kumpulan ganjaran pasukan setengah bulanan.",
    "monthlyCommissionTip4": "Penyelesaian ganjaran pasukan",
    "monthlyCommissionTip4Desc": "Dikira dua kali sebulan; jumlah tepat tertakluk pada hasil penyelesaian akhir sistem.",
    "consumptionRefund": "Komisen Jemput Rakan Buka Kad",
    "friendConsumptionRewardRefund": "Bayaran balik ganjaran rakan",
    "rewardRecordCardOpeningTitle": "[Rakan-{friendName}] komisen buka kad",
    "rewardRecordConsumptionTitle": "[{friendName}] belanja",
    "rewardRecordRefundTitle": "[{friendName}] bayaran balik",
    "rewardRecordCourseCommissionTitle": "[Rakan-{friendName}] komisen pembukaan kad Tahap 2",
    "rewardRecordFriendCourseCommissionTitle": "Jemput [{friendName}] - komisen pembukaan kad Tahap 2 rakan",
    "rewardRecordMonthlyCommissionTitle": "[{friendName}] komisen bulanan",
    "rewardRecordMonthlyBonusPoolTitle": "[{friendName}] komisen kumpulan bonus bulanan",
    "rewardRecordRegistrationTitle": "Jemput [{friendName}]",
    "invitationTotal": "Rujuk",
    "notUnlocked": "Belum dibuka",
    "purchaseCommissionTitle": "Ganjaran Kad",
    "purchaseCommissionIntro": "Dapat komisen apabila rakan mengaktifkan Kad WinPay.",
    "purchaseCommissionTip1": "Semakin tinggi tahap, semakin tinggi kadar komisen. ",
    "purchaseCommissionTip1Desc": "Jemput lebih ramai rakan untuk membuka kad. Setelah memenuhi syarat, anda boleh menyertai kumpulan bonus pasukan.",
    "purchaseCommissionTip2": "Kad maya dan fizikal menerima komisen yang sama selepas pengaktifan.",
    "purchaseCommissionTip2Desc": "",
    "purchaseCommissionTip3": "Ganjaran kad diselesaikan selepas dibuka",
    "purchaseCommissionTip3Desc": "Dibayar dalam 3 hari bekerja.",
    "purchaseCommissionTip3DescPrefix": "Dibayar dalam ",
    "purchaseCommissionTip3Time": "Kad berjaya diaktifkan, komisen diselesaikan serta-merta",
    "purchaseCommissionTip3DescSuffix": ". Ganjaran akan dikreditkan secara automatik ke akaun jumlah aset anda.",
    "purchaseCommissionConfirm": "Saya faham",
    "consumptionCommissionTitle": "Komisen Rujukan Tahap 2",
    "consumptionCommissionIntro": "Apabila pengguna yang anda jemput menjemput pengguna baharu, anda akan menerima ganjaran tambahan 25% daripada platform berdasarkan komisen yang dijana oleh pengguna baharu tersebut.",
    "consumptionCommissionTip1": "Peraturan ganjaran belanja",
    "consumptionCommissionTip1Desc": "Contoh: A menjemput B, kemudian B menjemput C. Jika C menjana komisen 25 USDT untuk B, A akan menerima ganjaran tambahan 6.25 USDT daripada platform.",
    "consumptionCommissionTip2": "Peraturan bayaran balik",
    "consumptionCommissionTip2Desc": "Bayaran balik 30 hari: tiada ganjaran.",
    "consumptionCommissionTip2Partial": "Bayaran balik sebahagian",
    "consumptionCommissionTip2PartialDesc": "Dikira semula ikut belanja layak.",
    "consumptionCommissionTip3": "Bayaran balik selepas ganjaran dibayar",
    "consumptionCommissionTip3Desc": "Pesanan dibayar balik atau dibatalkan boleh menarik semula ganjaran.",
    "points": "Mata Saya",
    "inviteMethod": "Cara jemput",
    "invitationCode": "Kod jemputan",
    "shareQr": "QR jemputan",
    "invitationLink": "Pautan jemputan",
    "myExclusiveInvite": "Rujukan Saya",
    "invitationCodeShort": "Code",
    "invitationLinkShort": "Pautan",
    "invitationRelationTip": "Guna kod/pautan untuk dikaitkan dan dapat ganjaran.",
    "recommender": "Pencadang",
    "enterRecommenderCode": "Masukkan kod",
    "scanRecommenderCode": "Imbas kod",
    "viewFullRecords": "Lihat Semua",
    "personUnit": "orang",
    "invitedFriendsTotal": "Jumlah Rujukan Sah",
    "pendingCommission": "Ganjaran Tertunda",
    "totalCommission": "Jumlah Ganjaran",
    "parentCode": "Penjemput",
    "enterParentCode": "Masukkan kod jemputan",
    "bind": "Sambungkan",
    "bound": "Terikat",
    "rewardDetails": "Butiran ganjaran",
    "commissionDetails": "Butiran komisen",
    "recommendedUsers": "Rakan dirujuk",
    "tradingFriends": "Rakan belanja",
    "registeredFriends": "Rakan berdaftar",
    "noRecommendedUsers": "Tiada rakan",
    "totalCommissionUsdt": "Jumlah Ganjaran（USDT）",
    "withdrawable": "Boleh Dituntut",
    "pendingSettlement": "Tertunda",
    "pendingSettlementTitle": "Menunggu (USDT)",
    "pendingSettlementDescription": "Selesaikan sebelum tuntut; bayaran balik membatalkan ganjaran.",
    "pendingSettlementQuestion": "Bila dibayar?",
    "pendingSettlementMonthlyCommission": "Komisen pasukan: dikira dua kali sebulan",
    "pendingSettlementCardActivation": "Pengaktifan kad: komisen diselesaikan dan dikreditkan serta-merta selepas kad berjaya diaktifkan",
    "pendingSettlementTransaction": "Komisen pembukaan kad Tahap 2: diselesaikan dan dikreditkan serta-merta selepas pembelian disahkan",
    "settled": "Selesai",
    "myRewards": "Ganjaran Saya",
    "date": "Tarikh",
    "selectDate": "Pilih Tarikh",
    "rewardSuccess": "Berjaya",
    "rewardReady": "Boleh dituntut",
    "rewardVoided": "Dibatalkan",
    "rewardPartialRefund": "Bayaran balik sebahagian",
    "rewardRefunded": "Dibayar balik",
    "rewardDeducted": "Ditolak",
    "rewardDeductionFailed": "Potongan gagal",
    "rewardCredited": "Telah dikreditkan",
    "rewardCardType": "Jenis kad",
    "rewardType": "Jenis ganjaran",
    "friendNickname": "Nama rakan",
    "invitationRelation": "Hubungan rujukan",
    "indirectFriend": "Rakan rujukan tidak langsung",
    "rewardAmount": "Ganjaran",
    "percentageWeight": "Wajaran peratusan",
    "deductionAmount": "Potongan",
    "commissionAllocationRatio": "Nisbah agihan",
    "commissionAllocationRatioUnavailable": "Belum tersedia",
    "commissionSettlementCycle": "Kitaran penyelesaian",
    "teamCommissionSettlementCycle": "Diselesaikan dua kali sebulan",
    "commissionSettlementMethod": "Kaedah penyelesaian",
    "commissionInstantSettlement": "Dikreditkan serta-merta",
    "commissionTriggerTime": "Masa pencetus",
    "commissionSettlementTime": "Masa bayaran",
    "friendConsumptionRefundTime": "Masa bayaran balik rakan",
    "commissionDeductionTime": "Masa potongan",
    "commissionStatus": "Status",
    "rewardDetailsAmountPrefix": "Butiran ganjaran ",
    "balanceAfter": "Baki ",
    "noRewardRecords": "Tiada rekod",
    "inviteSteps": "Langkah jemput",
    "step1": "Kongsi pautan atau kod",
    "step2": "Rakan yang dijemput melengkapkan pengesahan identiti dan memohon kad melalui pautan atau kod jemputan anda",
    "step3": "Anda akan menerima komisen apabila rakan mengaktifkan kad"
  },
  "task": {
    "title": "Dapatkan Mata dengan Daftar Masuk",
    "dailyCheckIn": "check-in harian",
    "howToGetPoints": "Cara Mendapatkan Mata",
    "myPoints": "Mata Saya",
    "dailyTasks": "Tugasan Harian",
    "checkInTotal": "Checked in for",
    "days": " hari berturut-turut",
    "checkInRules": "Peraturan Daftar Masuk",
    "checkInRuleOne": "Selepas daftar masuk hari ini, tuntut esok untuk mengekalkan rentetan daftar masuk.",
    "checkInRuleTwo": "Jika anda tidak menuntut di tengah jalan, anda boleh daftar masuk semula keesokan hari untuk meneruskannya.",
    "moreCheckInsMorePoints": "Lebih banyak daftar masuk, lebih banyak mata",
    "checkedInDaysPrefix": "Telah daftar masuk selama ",
    "checkedInDaysSuffix": " hari berturut-turut",
    "checkedInTodayTomorrow": "Sudah daftar masuk hari ini, tuntut esok",
    "routineTasks": "Tugasan Rutin",
    "dailyPointsLimit": "Daily points limit 1000",
    "basicGrowth": "Pertumbuhan Asas",
    "completeSignature": "Lengkapkan Tandatangan",
    "signatureDone": "Tandatangan Selesai",
    "pointsPlusOne": "Mata +1",
    "goFollow": "Pergi Ikuti",
    "postMoments": "Siar ke Moments",
    "perPost": "Setiap 1 Siaran",
    "monday": "Mon",
    "tuesday": "Tue",
    "wednesday": "Wed",
    "thursday": "Thu",
    "friday": "Fri",
    "saturday": "Sat",
    "sunday": "Sun"
  },
  "card": {
    "title": "Kad",
    "myCards": "Kad saya",
    "openCard": "Mohon kad",
    "benefits": "Manfaat Kad",
    "bill": "Bil",
    "empty": "Tiada Kad Berkaitan",
    "virtualCard": "Kad Maya",
    "physicalCard": "Kad fizikal",
    "courseCard": "Kad Kursus",
    "courseGiftNoticePhysical": "Selepas berjaya membeli kad fizikal, anda akan menerima kursus bersemuka eksklusif. Pautan kursus akan dihantar ke e-mel berdaftar anda; klik untuk melihat butiran dan cara menyertai.",
    "courseGiftNoticeVirtual": "Selepas berjaya membeli kad maya, anda akan menerima kursus bersemuka eksklusif. Pautan kursus akan dihantar ke e-mel berdaftar anda; klik untuk melihat butiran dan cara menyertai.",
    "applyCard": "Mohon kad",
    "applyNow": "Apply Now",
    "virtualDesc": "Contactless payments online and offline anytime, anywhere!",
    "physicalDesc": "Tiada yuran tahunan. Sokong ATM global!",
    "applyCardTypeOne": "Mohon kad maya",
    "applyCardTypeTwo": "Mohon kad fizikal",
    "applyCardTip1": "Mohon online untuk bayaran online dan offline",
    "applyCardTip2": "Kad fizikal dihantar ke rumah dan menyokong ATM serta POS",
    "applyCardTip3": "Mohon online, terima kad, kemudian aktifkan untuk guna",
    "applyCardTip4": "Lihat dan urus kad anda",
    "kycDialogTitle": "Sahkan identiti",
    "kycDialogDesc": "Selesaikan pengesahan identiti untuk membuka ciri ini",
    "kycDialogAction": "KYC sekarang",
    "useInstruction": "Panduan pautan kad",
    "virtualCardUseInstruction": "Arahan penggunaan kad maya",
    "entityCardUseInstruction": "Arahan penggunaan kad fizikal",
    "useInstructionText1": "Kad maya menyokong Alipay, Meituan dan bayaran online.",
    "useInstructionText2": "Kad fizikal menyokong Alipay, Meituan, bayaran online/offline, POS dan pengeluaran ATM.",
    "useInstructionText3": "Jangan kongsi nombor kad, tarikh luput atau CVV dengan orang lain.",
    "useInstructionText4": "Selepas penyahikatan, kad tidak boleh dipulihkan. Tindakan ini tidak boleh dibatalkan.",
    "useInstructionText5": "Selepas penyahikatan, yuran kad tidak dipulangkan, tetapi baki kad akan kembali ke dompet anda.",
    "useInstructionText6": "Jika perlukan bantuan, pergi ke Saya - Hubungi Kami - Sokongan Dalam Talian.",
    "useInstructionText7": "Cara mengikat",
    "useInstructionText8": "Alipay",
    "useInstructionText9": "Ikuti langkah berikut untuk mengikat kad anda dengan cepat dan mudah",
    "useInstructionText10": "Buka Alipay",
    "useInstructionText11": "Buka aplikasi Alipay dan ketik Saya",
    "useInstructionText12": "Pergi ke Kad Bank",
    "useInstructionText13": "Pilih pintu masuk tambah kad di bawah Kad Bank atau Tetapan Pembayaran",
    "useInstructionText14": "Tambah kad bank",
    "useInstructionText15": "Ketik Tambah Kad Bank dan masukkan nombor kad WinPay anda",
    "useInstructionText16": "Isi maklumat kad",
    "useInstructionText17": "Masukkan tarikh luput, CVV, kod pengesahan dan maklumat diperlukan.",
    "useInstructionText18": "Lengkapkan pengesahan",
    "useInstructionText19": "Selepas dihantar, lengkapkan pengesahan SMS atau keselamatan untuk selesai mengikat.",
    "useInstructionText20": "Arahan penggunaan kad",
    "bindCardInfo1": "Kad Visa ini dipilih untuk penggunaan Alipay dan boleh dipautkan dengan cepat melalui langkah berikut.",
    "bindCardInfo2": "Kad Visa ini dipilih untuk penggunaan Google Pay dan boleh dipautkan dengan cepat melalui langkah berikut.",
    "bindCardInfo3": "Kad Visa menyokong Apple Pay. Ikuti langkah berikut untuk memautkan kad dengan cepat.",
    "bindCardInfo4": "Muat turun dan buka Google Pay, kemudian log masuk",
    "bindCardInfo5": "Pada halaman utama Google Pay, ketik Tambah kad pembayaran",
    "bindCardInfo6": "Tambah kad pembayaran",
    "bindCardInfo7": "Pilih “Tambah kad kredit atau kad debit”.",
    "bindCardInfo8": "Isi maklumat peribadi",
    "bindCardInfo9": "Isi butiran kad dan alamat pengebilan, kemudian ketik Simpan dan teruskan",
    "bindCardInfo10": "Buka halaman terma pengeluar kad",
    "bindCardInfo11": "Tatal ke bawah dan ketik Teruskan",
    "bindCardInfo12": "Pilih kaedah pengesahan, minta dan masukkan kod pengesahan. Selepas pengesahan berjaya, kad akan dipautkan.",
    "bindCardInfo13": "Buka Apple Pay dan log masuk.",
    "bindCardInfo14": "Di halaman utama Apple Pay, pilih “Tambah Kad Pembayaran”.",
    "bindCardInfo15": "Imbas kad atau masukkan maklumat kad secara manual.",
    "bindCardInfo16": "Masukkan “Nombor Kad, Nama dalam Bahasa Inggeris, Tarikh Luput dan Kod Keselamatan”.",
    "bindCardInfo17": "Pergi ke halaman “Terma & Syarat”.",
    "bindCardInfo18": "Tatal ke bawah dan pilih “Setuju”.",
    "coreAdvantages": "Kelebihan utama",
    "recommendedAudience": "Pengguna yang disyorkan",
    "cardScene": "Card Scene",
    "transferIn": "Pindahan masuk",
    "transferOut": "Pindahan keluar",
    "atmPassword": "PIN ATM",
    "cardInfo": "Maklumat kad",
    "mycard": "Kad saya",
    "benefit": "Manfaat Kad",
    "recentTrade": "Bil",
    "viewAll": "Lihat semua",
    "noTrade": "No trade records",
    "noTradeEmpty": "Tiada data yang berkaitan",
    "inUse": "Sedang Digunakan",
    "inactive": "Belum aktif",
    "frozen": "Dibekukan",
    "processing": "Sedang diproses",
    "success": "Berjaya",
    "failed": "Gagal",
    "cardSensitiveTodo": "Sensitive card info flow migration in progress",
    "cardWallet": "Kad",
    "cardBenefits": "Manfaat Kad",
    "noBenefit": "No benefit info",
    "withdrawMin": "Min Withdraw",
    "withdrawMax": "Max Withdraw",
    "rechargeMin": "Min Recharge",
    "rechargeMax": "Max Recharge",
    "monthlyLimit": "Monthly Limit",
    "billDetail": "Butiran Bil",
    "feeRate": "Payment Fee",
    "chargeFeeLabel": "Charge Fee",
    "rechargeFeeLabel": "Initial Recharge",
    "withdrawFeeLabel": "Yuran Pengeluaran",
    "payFeeLabel": "Yuran Perbelanjaan",
    "selectCardTemplate": "Select Card Template",
    "selectScene": "Select Scene",
    "cardTemplate": "Card Template",
    "scene": "Scene",
    "selectTimeRange": "Pilih Julat Masa",
    "timeRangeTip": "Tukar kepada 180 hari terakhir untuk melihat butiran ganjaran",
    "last30Days": "30 Hari Terakhir",
    "last90Days": "90 Hari Terakhir",
    "last180Days": "180 Hari Terakhir",
    "currentScenario": "Current Scenario",
    "supportedScenes": "Supported Scenes",
    "supportedPlatforms": "Supported Platforms",
    "platformHint": "Subject to issuer support rules",
    "openCardAmount": "Yuran pembukaan kad",
    "openCardAmountTip": "Includes issuance fee and initial recharge",
    "openFeeNoticePrefix": "Yuran pembukaan kad",
    "openFeeNoticeSuffix": "akan dikreditkan ke dalam kad untuk memastikan kad kekal aktif",
    "firstRechargeTip": "Opening the card requires {amount} {symbol}, plus an initial recharge of {charge} {symbol}",
    "cardTitlePrefix": "Kad ",
    "cardUsageLimit": "Spending Limit",
    "monthlyCardUsageLimit": "Had penggunaan/bulan",
    "prepaidCard": "Kad prabayar",
    "identityInfo": "Maklumat Identiti",
    "identityInfoTip": "Verified details will be used for card opening checks",
    "firstName": "Nama",
    "lastName": "Nama Keluarga",
    "identityInfoEmpty": "Please complete verified identity details first",
    "agreementPrefix": "Saya telah membaca dan bersetuju",
    "optionalInvitationCode": "Masukkan kod jemputan (pilihan)",
    "openCardNotice": "Opening Notes",
    "openCardNotice1": "The opening cost consists of the issuance fee and initial recharge amount, processed automatically after submission.",
    "openCardNotice2": "Supported platforms and fees vary by scenario and issuing channel. Final rules are subject to the provider.",
    "openCardNotice3": "If you plan to apply for a physical card later, make sure you already hold a bindable virtual card.",
    "termsAgree": "I have read and agree to the User Agreement and Privacy Policy",
    "agreeFirst": "Please agree to the terms first",
    "noCardTemplate": "No card templates are currently available",
    "balanceOverview": "Gambaran manfaat kad",
    "withdrawNotice": "Minimum physical card withdrawal {amount} {symbol}",
    "applyPhysicalCard": "Apply Physical Card",
    "physicalApplyDesc": "Verify identity, choose a template, fill shipping information, and wait for card production after payment.",
    "shippingFee": "Shipping",
    "shippingFree": "Free",
    "applicationFee": "Application Fee",
    "applicationFeeLabel": "Yuran permohonan: ",
    "recentTradeScene": "Senario penggunaan terpilih",
    "physicalSceneDesc": "Perbelanjaan dalam talian dan luar talian",
    "physicalOrderNotice": "Physical Card Notes",
    "physicalNotice1": "Open a bindable virtual card before applying for a physical card.",
    "physicalNotice2": "After successful payment, the card enters production and delivery.",
    "physicalNotice3": "Activate the card after receiving it before use.",
    "fillShippingInfo": "Isi maklumat penghantaran",
    "requireVirtualCardFirst": "Open a bindable virtual card before applying for a physical card",
    "cardInfoTitle": "Maklumat kad",
    "shippingInfoTitle": "Maklumat penghantaran",
    "sameAsVirtualCard": "Sama seperti kad maya",
    "receiverName": "Nama",
    "enterReceiverName": "Masukkan",
    "completeAllInfo": "Sila lengkapkan semua maklumat",
    "addressMinLength": "Alamat mesti sekurang-kurangnya 5 aksara",
    "completeShippingAddress": "Complete shipping information. Address must be at least 5 characters.",
    "saveLabel": "Simpan",
    "confirmOrder": "Sahkan maklumat pesanan",
    "payPhysicalCardConfirm": "Confirm the physical card order and proceed to payment?",
    "payNow": "Bayar sekarang",
    "orderPaid": "Pembayaran berjaya",
    "paymentDetail": "Butiran pembayaran",
    "paymentFee": "Yuran dibayar",
    "paymentSuccess": "Pembayaran berjaya",
    "paymentSuccessDesc": "Kad anda sedang disediakan. Jangkaan tiba dalam 7-14 hari bekerja.",
    "physicalCardMakingTip": "Kad fizikal mengambil masa lebih lama. Aktifkan selepas diterima.",
    "paymentAmount": "Yuran dibayar",
    "physicalArrivalTip1": "Physical card production usually takes longer. Please wait patiently.",
    "physicalArrivalTip2": "Activate the card first after delivery before using it.",
    "viewPendingCards": "View Pending Cards",
    "totalAssetsInsufficientBalance": "Insufficient total assets. Please top up before continuing.",
    "currentCardInsufficientBalance": "Baki kad tidak mencukupi. Sila tambah nilai dahulu.",
    "topUpNow": "Pergi tambah nilai",
    "pendingPhysicalCards": "Kad belum aktif",
    "pendingActivate": "Belum aktif",
    "noPendingPhysicalCard": "No physical cards pending activation",
    "hasInactiveCards": "Mempunyai kad belum diaktifkan",
    "physicalInstruction": "Penerangan kad fizikal",
    "pendingNotice1": "You have successfully applied for a physical card. It is now being produced or shipped.",
    "pendingNotice2": "For account security, the physical card cannot be used before activation.",
    "pendingNotice3": "Selepas menerima kad, tekan butang di bawah untuk aktifkan.",
    "contactSupport": "Hubungi sokongan",
    "invitationCode": "Kod jemputan",
    "enterInvitationCode": "Masukkan kod jemputan (pilihan)",
    "openCardConfirm": "Submit card application?",
    "openCardSuccess": "Card application submitted",
    "kycTitle": "Pengesahan KYC",
    "kycVerify": "Pengesahan KYC",
    "kycRequirement": "Selesaikan pengesahan KYC sebelum memohon kad.",
    "kycRequirement1": "Provide real and accurate information consistent with your document.",
    "kycRequirement2": "Verification is reviewed by the provider and may take some time.",
    "kycIntroTip": "Submit real identity details first. After approval, you can continue opening a virtual card.",
    "verifyNow": "Sahkan Sekarang",
    "fillInfo": "Isi maklumat",
    "kycFormTip": "Fill in your usual contact details and billing address exactly as required.",
    "contactAndAddress": "Contact and Address",
    "countryCode": "Kod",
    "selectCountryCode": "Select code",
    "phoneNumber": "Nombor telefon",
    "enterPhone": "Masukkan nombor telefon anda",
    "address": "Alamat",
    "selectCountry": "Select country",
    "selectCountryRegion": "Pilih negara/rantau",
    "searchCountry": "Cari negara",
    "selectRegion": "Select state/province/region",
    "selectCity": "Pilih bandar",
    "enterAddress": "Enter detailed address",
    "postalCode": "Poskod",
    "enterPostalCode": "Enter postal code",
    "completeKycAddress": "Complete address info. Address must be at least 5 characters.",
    "kycSubmitted": "Information submitted",
    "kycReview": "Semakan Maklumat",
    "kycRejected": "Pengesahan KYC ditolak",
    "kycPending": "Maklumat dihantar, menunggu semakan",
    "kycApproved": "Maklumat diluluskan",
    "kycRejectedTip": "Please revise the information according to the rejection reason and resubmit.",
    "reviewTip": "Review finished, select a card to activate",
    "reviewDone": "saya faham",
    "cardCanOpen": "Kini anda boleh pilih kad",
    "resubmit": "Hantar semula",
    "failedReason": "Sebab Kegagalan",
    "activatePending": "{count} physical cards pending activation",
    "oldCardTransferTip": "Legacy cards do not support transfer in / out after the WinPay card service upgrade.",
    "oldCardServiceUpgradeNotice": "Sila semak semula selepas naik taraf perkhidmatan kad lama selesai.",
    "cardProcessingWait": "Card is still processing. Please try again later.",
    "cardBalance": "Card Balance",
    "accountBalance": "Funding Balance",
    "availableBalanceLabel": "Baki Tersedia:",
    "rechargeCurrencyTitle": "Mata Wang Pengisian",
    "rechargeAmountTitle": "Jumlah tambah nilai",
    "monthlyFee": "Yuran Bulanan",
    "supportedConsumptionScenes": "Senario sokongan penggunaan",
    "keySupportedPlatforms": "Platform Utama yang Disokong",
    "allSupportedPlatforms": "Semua platform disokong",
    "otherServices": "Other Services",
    "otherPlatforms": "Perkhidmatan Lain",
    "cardUsageRules": "Garispanduan penggunaan kad",
    "usageRule1": "Kadar bayaran balik, kadar pembatalan, kadar kegagalan, kadar pengesahan yang terlalu tinggi mempunyai risiko kad dibekukan",
    "usageRule2": "Dilarang digunakan di platform seperti Steam, Blizzard, EA, Battle.net, OYSTER LABS",
    "usageRule3": "Dilarang mengikat platform langganan untuk pemotongan automatik",
    "cardSafetyTips": "Petua keselamatan penggunaan kad",
    "cardSafetyTip1": "Jangan beritahu orang lain nombor kad, tarikh luput, CVV dan maklumat anda dengan mudah",
    "cardSafetyTip2": "Sila gunakan kad prabayar secara sah dan hanya dalam skop pematuhan kad.",
    "unbindCard": "Lepaskan Kad",
    "unBindCardText_1": "Sebelum menyahikat kad anda, sila ambil perhatian tentang baki pada kad:",
    "unBindCardText_2": "Baki kad akan dipulangkan ke aset akaun anda dalam 1-7 hari bekerja selepas penyahikatan. Semak rekod dana atau hubungi sokongan.",
    "unBindCardText_3": "Kesan berikut akan berlaku selepas penyahikatan",
    "unBindCardText_4": "Kad ini tidak lagi boleh digunakan untuk pembayaran dan transaksi berkaitan",
    "unBindCardText_5": "Perkhidmatan potongan automatik yang terikat pada kad ini mungkin terjejas",
    "unBindCardText_6": "Selepas penyahikatan, kad ini tidak boleh diikat semula",
    "unBindCardText_7": "Penyahikatan sedang diproses",
    "unBindCardText_8": "Sedang menyahikat kad...",
    "unBindCardText_9": "Sila tunggu, dijangka mengambil masa dua minit",
    "unBindCardText_10": "Untuk melindungi dana anda, penyahikatan tidak boleh dipulihkan",
    "unBindCardText_11": "Berjaya dinyahikat",
    "unBindCardText_12": "Kad berjaya dinyahikat",
    "unBindCardText_13": "Kad anda telah berjaya dinyahikat dan tidak lagi akan muncul dalam senarai kad",
    "unBindCardText_14": "Penyahikatan gagal",
    "unBindCardText_15": "Penyahikatan kad gagal",
    "unBindCardText_16": "Gagal menyahikat kad ini. Sila cuba lagi nanti.",
    "unBindCardText_17": "Kad yang telah dinyahikat",
    "unBindCardText_18": "Dinyahikat",
    "unBindCardText_19": "Butiran kad yang telah dinyahikat",
    "unBindCardText_20": "Baki semasa menyahikat kad:",
    "unBindCardText_21": "Adakah bayaran balik baki berjaya:",
    "unBindCardText_22": "Masa penyahikatan kad:",
    "unbindCardStatus": "Status kad",
    "unbindRefundYes": "Ya",
    "unbindRefundPending": "Sedang diproses",
    "minAmount": "Minimum Amount",
    "exchangeRate": "Harga Semasa",
    "chargeArrivalTitle": "Jumlah tambah nilai",
    "expectedCardArrival": "Anggaran penerimaan",
    "expectedAccountArrival": "Pengeluaran Sampai",
    "submitTransfer": "Sahkan",
    "transferSuccess": "Pemindahan Dihantar",
    "transferSuccessTitle": "Petua",
    "transferInSuccessDesc": "Tahniah! Anda telah berjaya tambah nilai.",
    "transferOutSuccessDesc": "Tahniah, pengeluaran anda berjaya",
    "enterChargeAmount": "Masukkan jumlah tambah nilai",
    "enterTransferInAmount": "Enter transfer in amount",
    "enterTransferOutAmount": "Enter transfer out amount",
    "enterValidAmount": "Enter a valid amount",
    "tradeDetail": "Butiran",
    "tradeProcessingTip": "This transaction is still processing. Check back later for the final result.",
    "cardNumber": "Nombor Kad",
    "tradeType": "Jenis Transaksi",
    "tradeDescription": "Catatan",
    "merchant": "Merchant",
    "amount": "Amount",
    "tradeAmount": "Jumlah Transaksi",
    "orderNumber": "Order Number:",
    "orderId": "Order ID",
    "tradeTime": "Masa",
    "noTradeDetail": "No trade detail available",
    "cvvTip": "The CVV is the 3 or 4 digit code on the back of the card used to verify your identity.",
    "sensitiveInfoLocked": "Wallet password verification is required before viewing the card number, expiry date, and CVV.",
    "sensitiveInfoLockedDesc": "For account safety, sensitive card information stays hidden until verification succeeds.",
    "unlockNow": "Verify and Unlock",
    "myCard": "Kad saya",
    "basicInfo": "Maklumat kad",
    "cardType": "Jenis kad",
    "cardholder": "Pemegang kad",
    "phoneNumberLabel": "Nombor telefon",
    "validThru": "Valid Thru (MM/YY)",
    "validThroughLabel": "Sah hingga",
    "cvvCode": "CVV",
    "openSecurePage": "Open secure page in new window",
    "openVerificationPage": "Open verification page",
    "checkVerificationStatus": "Check verification status",
    "verificationPageUnavailable": "Verification page is unavailable for now. Please check the status later.",
    "diditSdkTitle": "Didit Face Verification",
    "sdkIdle": "Not started",
    "sdkLoading": "Loading verification",
    "sdkReady": "Verification in progress",
    "sdkUnavailable": "Failed to load Didit SDK. Open it externally instead.",
    "sdkCancelled": "KYC verification was cancelled",
    "sdkDeclined": "KYC verification was declined",
    "restartVerification": "Restart verification",
    "sdkCurrentStep": "Current Step",
    "sdkLastEvent": "Last Event",
    "sdkStepDocumentSelection": "Select document type",
    "sdkStepDocumentFront": "Capture document front",
    "sdkStepDocumentBack": "Capture document back",
    "sdkStepFace": "Face verification",
    "sdkStepEmail": "Email verification",
    "cameraPermissionTitle": "Enable Camera Permission",
    "cameraPermissionTip": "Document capture and face verification require browser camera access. Please grant camera permission first.",
    "cameraPermissionDenied": "Camera permission is not available right now. Please allow camera access in your browser settings before continuing.",
    "cameraPermissionGranted": "Camera permission is ready. You can continue with document capture and face verification.",
    "cameraPermissionGrantedToast": "Camera permission enabled",
    "cameraPermissionOpen": "Enable",
    "cameraPermissionReady": "Enabled",
    "cameraPermissionDialog": "Browser camera permission is currently unavailable. Please allow camera access from the browser address bar or system settings, then continue with KYC verification.",
    "sdkStepPhone": "Phone verification",
    "sdkStepPoa": "Proof of address",
    "sdkStepQuestionnaire": "Questionnaire",
    "sdkEventReady": "Verification page ready",
    "sdkEventStarted": "Verification started",
    "sdkEventStepStarted": "Step started",
    "sdkEventStepCompleted": "Step completed",
    "sdkEventStepChanged": "Step changed",
    "sdkEventMediaStarted": "Capture started",
    "sdkEventMediaCaptured": "Capture completed",
    "sdkEventDocumentSelected": "Document selected",
    "sdkEventSubmitted": "Verification submitted",
    "sdkEventCodeSent": "Code sent",
    "sdkEventCodeVerified": "Code verified",
    "sdkEventStatusUpdated": "Status updated",
    "sdkEventCompleted": "Verification completed",
    "sdkEventCancelled": "Verification cancelled",
    "sdkEventError": "Verification error",
    "sdkEventCloseRequest": "Close requested",
    "kycTokenEmpty": "KYC token is empty. Please try again later.",
    "viewAtmPassword": "Lihat PIN ATM",
    "enterAtmPassword": "Enter 6-digit ATM PIN",
    "confirmAtmPassword": "Sahkan PIN ATM",
    "atmPasswordTip": "*Kata laluan ini hanya boleh ditetapkan sekali dan boleh dilihat kemudian.",
    "sixDigitPin": "Enter a 6-digit numeric PIN",
    "setPinSuccess": "Kata laluan berjaya ditetapkan",
    "GoOpenCard": "Buka Kad"
  },
  "mine": {
    "title": "Akaun Saya",
    "mineCode": "QR Kod Saya",
    "scanAddFriend": "Scan to add as WinPay Wallet friend",
    "wallet": "Urus Wallet",
    "cardCodeRedemption": "Tebus Kod Kad",
    "enterCardCode": "Masukkan Kod Kad",
    "security": "Tetapan keselamatan",
    "language": "Tukar Bahasa",
    "selectLanguage": "Bahasa",
    "contactUs": "Hubungi kami",
    "about": "Tentang Kami",
    "kyc": "Pengesahan KYC",
    "userId": "User ID",
    "login": "Login/Register",
    "logout": "Daftar Keluar",
    "logoutConfirm": "Log out of the current account?",
    "logoutConfirmTitle": "Sahkan Daftar Keluar?",
    "logoutConfirmAccount": "Adakah anda pasti mahu daftar keluar daripada akaun semasa [{name}]?",
    "points": "Mata",
    "currentLevel": "Tahap semasa",
    "totalPoints": "Jumlah mata",
    "nextLevelPoints": "{points} points to the next level",
    "levelSurpassed": "Current level exceeded",
    "maxLevelReached": "Maximum level reached",
    "exclusiveLevel": "Tahap eksklusif",
    "dailyCheckInPoints": "Daftar masuk harian dapat mata",
    "rewardDetails": "Butiran ganjaran",
    "signIn": "Daftar masuk",
    "signedIn": "Sudah daftar masuk",
    "checkInSuccess": "Check-in successful, earned {reward} points",
    "gameZone": "Zon permainan",
    "gameDesc": "Mudah dapat mata",
    "shopZone": "Zon e-dagang",
    "shopDesc": "Pesan untuk dapat mata",
    "enterZone": "Enter",
    "inviteFriends": "Jemput",
    "inviteDesc": "Invite friends to WinPay",
    "invitedUsers": "Invited registered wallets",
    "recommender": "Inviter",
    "bindSuccess": "Berjaya diikat",
    "takePhoto": "Ambil Gambar",
    "chooseFromAlbum": "Choose from Library",
    "avatarUpdated": "Avatar updated",
    "avatarUploadFailed": "Avatar upload failed. Please try again later.",
    "avatarImageOnly": "Please choose an image file",
    "avatarImageTooLarge": "Image size must be under {size}MB",
    "changeWalletName": "Rename Wallet",
    "enterWalletName": "Masukkan Nama Dompet",
    "nameTooLong": "Name cannot exceed 16 characters",
    "nameUpdated": "Name updated",
    "securityTodo": "Security settings migration in progress",
    "kycTodo": "Sahkan Sekarang",
    "kycPending": "Pending",
    "kycVerified": "Telah Disahkan",
    "kycFailed": "Gagal",
    "kycTodoDesc": "Selesaikan pengesahan KYC sebelum meneruskan ciri kad maya atau fizikal.",
    "kycPendingDesc": "Your verification materials have been submitted and are under review.",
    "kycVerifiedDesc": "Pengesahan KYC selesai dan pengesahan berkaitan kad tersedia untuk akaun ini.",
    "kycFailedDesc": "Verification was not approved. Please review the reason and submit again.",
    "viewKycResult": "View Result",
    "retryKyc": "Retry Verification",
    "aboutDesc": "One-stop Web3 social and payment wallet",
    "version": "Version",
    "contactDesc": "If you have any questions, such as wallet deletion or usage issues, please contact us through the following methods:",
    "supportEmail": "Emel khidmat pelanggan",
    "onlineSupport": "Khidmat pelanggan dalam talian",
    "serviceMailbox": "Customer Service Mailbox",
    "serviceHours": "Support Hours",
    "weekdayHours": "Working Days: 09:00 AM - 06:00 PM",
    "supportReplyTip": "Kami akan balas pada waktu operasi.",
    "supportThanks": "Thank you for your support and understanding."
  },
  "article": {
    "square": "square",
    "followTab": "Ikuti",
    "likeTab": "Koleksi",
    "nowTab": "instant",
    "create": "Terbitkan",
    "myArticle": "My Articles",
    "detail": "Article Detail",
    "addToken": "Tambah token",
    "addNft": "Tambah NFT",
    "reportTitle": "Aduan",
    "reportSuccess": "Thanks for your feedback.",
    "reportFailed": "Submit failed. Cuba lagi nanti.",
    "reasonAttack": "Serangan dan provokasi",
    "reasonPorn": "Lucah dan vulgar",
    "reasonDiscomfort": "Tidak selesa",
    "reasonSpam": "Iklan spam",
    "follow": "ikuti",
    "followed": "Sudah mengikuti",
    "followSuccess": "Sudah mengikuti",
    "unfollowSuccess": "Penjejakan dibatalkan",
    "likeSuccess": "Liked",
    "unlikeSuccess": "Unliked",
    "now": "hanya",
    "minutesAgo": "minit lalu",
    "hoursAgo": "jam yang lalu",
    "daysAgo": "Beberapa hari yang lalu",
    "views": "Views",
    "forwarded": "Hantar semula",
    "empty": "No content",
    "searchPlaceholder": "Cari",
    "unsupportedNetwork": "The current network does not support home content.",
    "switchNetwork": "Tukar rangkaian",
    "observerWalletWarn": "Watch-only wallets cannot access home content.",
    "switchWallet": "Switch Wallet",
    "openDetailTodo": "Article detail is pending migration",
    "createTodo": "Article publishing is pending migration",
    "addTokenTodo": "Add token is pending migration",
    "addNftTodo": "Add NFT is pending migration",
    "sampleName": "WinPay User",
    "sampleTopic": "Flutter article module migration preview",
    "sampleContent": "This page carries the migrated H5 styles, state, and sheet interaction for article modules."
  }
};
